export default __webpack_public_path__ + "static/media/flex_s44lac.428def7d.jpg";